import React from 'react';

import { getStoreCartPriceChangeWarningMessage } from '@/modules/Cart/StoreCart/helpers/storeCartPricing.utils';

import './StoreCartPriceChangeWarning.scss';

const STORE_CART_PRICE_CHANGE_WARNING_ICON = '/src/assets/svg/warning_circle.svg';

type StoreCartPriceChangeWarningVariant = 'inline' | 'alert';

interface IStoreCartPriceChangeWarningProps {
  currentPrice?: number;
  previousPrice?: number;
  message?: string;
  className?: string;
  variant?: StoreCartPriceChangeWarningVariant;
  children?: React.ReactNode;
}

const StoreCartPriceChangeWarning: React.FC<IStoreCartPriceChangeWarningProps> = ({
  currentPrice,
  previousPrice,
  message,
  className = '',
  variant = 'inline',
  children,
}) => {
  const resolvedMessage =
    message ??
    (currentPrice != null && previousPrice != null
      ? getStoreCartPriceChangeWarningMessage(currentPrice, previousPrice)
      : null);

  if (!resolvedMessage && !children) {
    return null;
  }

  return (
    <div
      className={`store-cart-price-change-warning store-cart-price-change-warning--${variant}${
        className ? ` ${className}` : ''
      }`}
      role="status"
    >
      <img
        src={STORE_CART_PRICE_CHANGE_WARNING_ICON}
        alt=""
        aria-hidden="true"
        className="store-cart-price-change-warning__icon"
        width={12}
        height={12}
      />
      <span className="store-cart-price-change-warning__message">
        {children ?? resolvedMessage}
      </span>
    </div>
  );
};

StoreCartPriceChangeWarning.displayName = 'StoreCartPriceChangeWarning';

export default StoreCartPriceChangeWarning;
